import APIClient from './index';

export const getDiscoverUsers = (
  Brand_id,
  {
    sortBy = 'affinity',
    page = 0,
    limit = 25,
    getDetailedResults = false,
    minAffinity = null,
    selectedSegments = [],
    skipCounts = false,
    query = '',
    tagids = [],
    listids = []
  } = {}
) => {
  return new Promise((resolve, reject) => {
    APIClient.post('/Discover/users', {
      Brand_id, sortBy, page, limit, getDetailedResults, minAffinity, selectedSegments, skipCounts, query, tagids, listids
    })
      .then(response => resolve(response.data))
      .catch(err => reject(err?.data?.error));
  });
};

export const getDiscoverVibe = (
  Brand_id,
  {
    vibeQuery,
    minAffinity = null,
    affinityCeiling = null,
    topKPerBucket = 200,
    selectedSegments = [],
    tagids = [],
    listids = [],
  } = {}
) =>
  new Promise((resolve, reject) => {
    APIClient.post('/Discover/vibe', {
      Brand_id, vibeQuery, minAffinity, affinityCeiling, topKPerBucket,
      selectedSegments, tagids, listids,
    })
      .then(response => resolve(response.data))
      .catch(err => reject(err?.data?.error));
  });

// Polished "why surfaced" prose for a whole grid of vibe creators in one call;
// each creator carries its own grounding + a creatorId the response is keyed by.
// Returns { success, explainers: [{ creatorId, explainer }] }.
export const getDiscoverVibeExplainers = (
  Brand_id,
  {
    vibeQuery,
    creators = [],
  } = {}
) =>
  new Promise((resolve, reject) => {
    APIClient.post('/Discover/vibe-explainers', { Brand_id, vibeQuery, creators })
      .then(response => resolve(response.data))
      .catch(err => reject(err?.data?.error));
  });
